import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from "moment";
import { DashboardService } from '../../services/dashboard.service';
import { ClientSideStorageService } from '../../services/client-side-storage.service';
import { environment } from 'src/environments/environment';
import autoTable from 'jspdf-autotable';
import jsPDF from 'jspdf';
import { CommonUtilService } from 'src/app/services/common-util.service';


@Component({
  selector: 'app-event-deal-report',
  templateUrl: './event-deal-report.component.html',
  styleUrl: './event-deal-report.component.scss'
})
export class EventDealReportComponent {
  placeholders = environment.placeholders as { [key: string]: string };
  @Input() deals: any[] = [];
  reportPlaceHolders: any;
  userData: any;
  alldata: any = [];
  allpdfdata: any = [];
  allCategory: any;
  brandlogo: any;
  merchantDate: any;
  constructor(private router: Router, private service: CommonUtilService, private route: ActivatedRoute, private clientStorage: ClientSideStorageService, private dashboardService: DashboardService) {
    this.userData = JSON.parse(this.clientStorage.get("marketplaceData"));
    let parsedcreatedDate = moment(this.userData.created_date, "YYYY-MM-DD");
    this.merchantDate = parsedcreatedDate.format("DD/MM/YYYY");
    this.brandlogo = environment.assetsUrl + '/assets/' + this.userData?.marketplace_image
    this.reportPlaceHolders = this.placeholders['Reports_page']
    this.route.data.subscribe((data: any) => {
      this.allCategory = data?.resolvedData.data;
      this.dashboardService.setData(data?.resolvedData);
    });
  }

  ngOnInit() {
    this.getUserData()
    const today = new Date();

    // Current date → yyyy-MM-dd
    this.dateTo = today.toISOString().split('T')[0];

    // 3 months before
    const threeMonthsAgo = new Date(today);
    threeMonthsAgo.setMonth(today.getMonth() - 3);
    this.dateFrom = threeMonthsAgo.toISOString().split('T')[0];
    this.getAllDealsData()

  }

  viewDetails(deal: any) {
    this.router.navigate(['/eventreport/deal-events'], { state: { deal } });

  }

  reportTotalDeals: any;
  reportTotalBudget: any;
  reportTotalSpent: any;
  reportSpendCharged: any;
  eventsData: any;
  getAllDealsData() {

    const payload = {
      page: this.currentPage,
      status: this.selectedStatus || '',
      fromdate: moment(this.dateFrom).format('MM/DD/YYYY') || '',
      todate: moment(this.dateTo).format('MM/DD/YYYY') || '',
      fetchall: false
    }

    this.dashboardService.getAllDeals(this.userData.marketplace_id, payload).subscribe((res: any) => {

      this.reportTotalDeals = res?.body?.data?.TOTAL_DEALS;
      this.reportTotalSpent = res?.body?.data?.TOTAL_ACTUAL_SPENT;
      this.reportTotalBudget = res?.body?.data?.TOTAL_BUDGET;
      this.reportSpendCharged = res?.body?.data?.TOTAL_SPENT_CHARGED;
      if (this.currentPage === 1) {
        this.eventsData = res?.body?.data?.eventsData
      }
      if (res && res?.body.data && res?.body.data.DEALS && res?.body.data.DEALS.length !== 0) {
        res?.body.data.DEALS.forEach((item: any) => {
          let tableData = item;

          if (item && item.categories) {
            let categoryTypes: string[] = [];
            item.categories.forEach((categoryId: number) => {
              let data = this.allCategory?.find((i: any) => i.category_id === categoryId);
              if (data) {
                categoryTypes.push(data.category_type);
              }
            });
            let parsedDate = moment(tableData.created_date, "YYYY-MM-DD");
            tableData.created_date = parsedDate.format("DD/MM/YYYY");
            let parsedavailabletoDate = moment(new Date(tableData.available_to), "YYYY-MM-DD");
            tableData.available_to = parsedavailabletoDate.format("DD/MM/YYYY");
            let parsedavailablefromDate = moment(new Date(tableData.available_from), "YYYY-MM-DD");
            tableData.available_from = parsedavailablefromDate.format("DD/MM/YYYY");
            tableData.category_type = categoryTypes.join(', ');
            this.alldata.push(tableData);
            this.deals = this.alldata
          }
        }
        )
      }
      // this.setFilteredDeals(this.deals);
    });


  }

  currentPage = 1;
  itemsPerPage = 10;
  get totalPages(): number {
    return Math.ceil(this.reportTotalDeals / this.itemsPerPage);
  }

  get paginatedDeals(): any[] {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    return this.deals.slice(start, start + this.itemsPerPage);
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.getAllDealsData()
    }
  }

  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.getAllDealsData()
    }
  }

  getStatusLabel(status: string): string {
    switch (status) {
      case 'P': return this.reportPlaceHolders['LBL_PENDING'];
      case 'A': return this.reportPlaceHolders['LBL_ACTIVE'];
      case 'I': return this.reportPlaceHolders['LBL_INACTIVE'];
      case 'D': return this.reportPlaceHolders['LBL_DRAFT'];
      case 'C': return this.reportPlaceHolders['LBL_COMPLETED'];
      case 'E': return this.reportPlaceHolders['LBL_EXPIRED'];
      default: return status;
    }
  }

  getStatusClass(status: string): any {
    switch (status) {
      case 'A': return 'active-chip';
      case 'P': return 'pending-chip';
      case 'S': return 'paused-chip'
      case 'E': return 'expired-chip';
      case 'IA': return 'inactive-chip';
      case 'D': return 'draft-chip';
      case 'U': return 'upcoming-chip';
      case 'R': return 'rejected-chip';
      case 'N': return 'new-chip';
      case 'C': return 'completed-chip';
      default: return '';
    }
  }

  getFullImageUrl(imagePath: string): string {
    return `${environment.assetsUrl}/assets/${imagePath}`;
  }

  filteredData: any[] = [];

  customOkClick() {
    // this.deals = this.alldata
    this.deals = []
    this.alldata = []
    this.currentPage = 1;
    this.filteredData = []
    this.filteredData = this.alldata.filter((item: any) => {
      const matchesStatus = this.selectedStatus ? item.status === this.selectedStatus : true;

      const itemFromDate = item.available_from_local ? item.available_from_local : null;
      const itemToDate = item.available_to_local ? item.available_to_local : null;

      const filterFromDate = this.dateFrom ? new Date(this.dateFrom) : null;
      const filterToDate = this.dateTo ? new Date(this.dateTo) : null;

      // Normalize to date only (remove time by using yyyy-mm-dd strings)
      const itemFromDateStr = itemFromDate ? itemFromDate.slice(0, 10) : null;
      const itemToDateStr = itemToDate ? itemToDate.slice(0, 10) : null;
      const filterFromDateStr = filterFromDate ? filterFromDate.toISOString().slice(0, 10) : null;
      const filterToDateStr = filterToDate ? filterToDate.toISOString().slice(0, 10) : null;

      let matchesDate = true;

      if (filterFromDateStr && filterToDateStr) {
        matchesDate =
          (!itemFromDateStr || itemFromDateStr >= filterFromDateStr) &&
          (!itemToDateStr || itemToDateStr <= filterToDateStr);
      } else if (filterFromDateStr && !filterToDateStr) {
        matchesDate = !itemFromDateStr || itemFromDateStr >= filterFromDateStr;
      } else if (!filterFromDateStr && filterToDateStr) {
        matchesDate = !itemToDateStr || itemToDateStr <= filterToDateStr;
      }


      return matchesStatus && matchesDate;
    });

    // this.setFilteredDeals(this.filteredData)
    this.getAllDealsData();
  }

  selectedStatus = 'A,C,E'; // For dropdown filter
  dateFrom = '';
  dateTo = '';
  statusList = ['Pending', 'Draft', 'Completed', 'Active', 'Expired'];

  filteredDeals = [...this.alldata]; // Copy of original data


  setFilteredDeals(deals: any[]) {

    this.deals = deals.filter(deal => ['A', 'E', 'C'].includes(deal.status));
    this.reportTotalDeals = this.deals.length;
    this.calculateSummary()
  }

  calculateSummary(): void {
    this.reportTotalDeals = this.deals.length;
    this.reportTotalSpent = +this.deals.reduce((sum: any, deal: any) => sum + (deal.total_spent || 0), 0).toFixed(2);
    this.reportTotalBudget = +this.deals.reduce((sum: any, deal: any) => sum + (deal.budget || 0), 0).toFixed(2);
    this.reportSpendCharged = +this.deals.reduce((sum: any, deal: any) => sum + (deal.spentAlreadyCharged || 0), 0).toFixed(2);
  }

  resetFilters() {
    this.alldata = []
    this.deals = []
    this.selectedStatus = 'A,C,E';
    this.dateFrom = '';
    this.dateTo = '';
    const today = new Date();

    // Current date → yyyy-MM-dd
    this.dateTo = today.toISOString().split('T')[0];

    // 3 months before
    const threeMonthsAgo = new Date(today);
    threeMonthsAgo.setMonth(today.getMonth() - 3);
    this.dateFrom = threeMonthsAgo.toISOString().split('T')[0];
    // this.dashboardForm.get('filterStatus')?.setValue('');
    // this.filteredDeals = [...this.alldata];
    // this.setFilteredDeals(this.alldata)
    this.getAllDealsData();
    // this.last3MonthData()
  }

  goBack() {
    this.router.navigate(['/reportsdashboard']);
  }

  alldealsdata: any;
  GetAllPdfData() {
    const payload = {
      page: this.currentPage,
      status: '',
      // fromdate: '',
      // todate:  '',
      fetchall: true
    }
    this.dashboardService.getAllDeals(this.userData.marketplace_id, payload).subscribe((res: any) => {

      this.reportTotalDeals = res?.body?.data?.TOTAL_DEALS;
      this.reportTotalSpent = res?.body?.data?.TOTAL_ACTUAL_SPENT;
      this.reportTotalBudget = res?.body?.data?.TOTAL_BUDGET;
      this.reportSpendCharged = res?.body?.data?.TOTAL_SPENT_CHARGED;
      this.eventsData = res?.body?.data?.eventsData
      if (res && res?.body.data && res?.body.data.DEALS && res?.body.data.DEALS.length !== 0) {
        res?.body.data.DEALS.forEach((item: any) => {
          let tableData = item;

          if (item && item.categories) {
            let categoryTypes: string[] = [];
            item.categories.forEach((categoryId: number) => {
              let data = this.allCategory?.find((i: any) => i.category_id === categoryId);
              if (data) {
                categoryTypes.push(data.category_type);
              }
            });
            let parsedDate = moment(tableData.created_date, "YYYY-MM-DD");
            tableData.created_date = parsedDate.format("DD/MM/YYYY");
            let parsedavailabletoDate = moment(new Date(tableData.available_to), "YYYY-MM-DD");
            tableData.available_to = parsedavailabletoDate.format("DD/MM/YYYY");
            let parsedavailablefromDate = moment(new Date(tableData.available_from), "YYYY-MM-DD");
            tableData.available_from = parsedavailablefromDate.format("DD/MM/YYYY");
            tableData.category_type = categoryTypes.join(', ');
            this.allpdfdata.push(tableData);
            this.alldealsdata = this.allpdfdata
          }
        }
        )
      }
      // this.setFilteredDeals(this.deals);

      this.generatePDF();
    });
  }

  generatePDF1() {
    const doc = new jsPDF();
    const reportDate = this.getFormattedDateTime(); // Get current date
    let address = `${this.userData.addressLine1}, ${this.userData.city_name}, ${this.userData.country_name}`;

    // If address length exceeds 150, insert a newline after 150 characters
    if (address.length > 150) {
      const breakpoint = address.lastIndexOf(' ', 150); // Break at the last space before 150
      address = address.slice(0, breakpoint) + '\n' + address.slice(breakpoint + 1);
    }
    // 🏢 Merchant Details
    const merchantDetails = `${this.reportPlaceHolders['LBL_MERCHANT']}: ${this.userData.marketplace_name},
  Status: ${this.getStatusLabel(this.userData.status)}
  ${this.reportPlaceHolders['LBL_ADDRESS']}: ${address}
  Mobile: +${this.profiledata.mobile_country_code + this.profiledata.mobile}
  ${this.reportPlaceHolders['LBL_CONTACT']}: +${this.userData.phone_country_code + this.userData.business_contact_number}
  Report Date: ${reportDate}
      `;

    // Load the brand logo (Base64 or image path)
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = 'assets/images/expenses.png'; //environment.assetsUrl + '/assets/' + this.userData?.marketplace_image // Change path as needed

    img.onload = () => {
      // Convert image to Base64 and add to PDF
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = img.width;
      canvas.height = img.height;
      ctx?.drawImage(img, 0, 0);

      const imgData = canvas.toDataURL("image/png");

      // Add Logo to PDF


      // 🎨 Style the Header (Like an Invoice)
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(18);
      doc.text('DEALS REPORT', 105, 20, { align: 'center' });

      doc.addImage(imgData, 'PNG', 10, 20, 40, 30);
      doc.setFontSize(12);
      doc.setFont('helvetica', 'normal');
      // doc.text(merchantDetails, 60, 27);
      const merchantLines = doc.splitTextToSize(merchantDetails, 130); // Wrap at 130px width
      doc.text(merchantLines, 60, 27);

      // 🏷️ Table Headers
      const tableColumn = ['Unique ID', `${this.reportPlaceHolders['TBL_NAME']}`, `${this.reportPlaceHolders['TBL_CREATED_DATE']}`, `${this.reportPlaceHolders['TBL_AVAILABLE_TO']}`, 'Category', `${this.reportPlaceHolders['TBL_STATUS']}`, `${this.reportPlaceHolders['TBL_BUDGET']}`, `${this.reportPlaceHolders['TBL_TOTAL_SPENT']}`, `${this.reportPlaceHolders['TBL_CHARGED']}`];
      const tableRows: any[] = [];

      // 🔄 Loop through data & format rows
      this.alldealsdata.forEach((deal: any) => {
        tableRows.push([
          deal.uuid,
          deal.product_name,
          deal.created_date,
          deal.available_to,
          deal.category_type,
          this.getStatusLabel(deal.status),
          `${deal.budget}`,
          `${deal.total_spent}`,
          `${deal.spentAlreadyCharged}`,
        ]);
      });

      doc.setLineWidth(0.5); // Set line thickness
      doc.line(10, 63, 200, 63);

      const startY = 68; // Position below line
      doc.setFontSize(11);
      doc.setFont('helvetica', 'bold');

      doc.text(`${this.reportPlaceHolders['LBL_TOTAL_DEALS']}:`, 20, startY);
      doc.text(`${this.reportTotalDeals}`, 49, startY);

      doc.text(`${this.reportPlaceHolders['LBL_TOTAL_BUDGET']}:`, 55, startY);
      doc.text(`$${this.reportTotalBudget}`, 80, startY);

      doc.text(`${this.reportPlaceHolders['LBL_TOTAL_SPENT']}:`, 100, startY);
      doc.text(`$${this.reportTotalSpent}`, 129, startY);

      doc.text(`${this.reportPlaceHolders['LBL_TOTAL_CHARGED']}:`, 150, startY);
      doc.text(`$${this.reportSpendCharged}`, 180, startY);



      // Draw another line below summary for separation
      doc.line(10, startY + 5, 200, startY + 5); // (x1, y1, x2, y2)

      // 🏆 Generate Table with AutoTable (Add Padding & Styling)
      autoTable(doc, {
        head: [tableColumn],
        body: tableRows,
        startY: 75,
        margin: { left: 10 },
        theme: 'grid',
        styles: { fontSize: 8, cellPadding: 3 }, // Add padding inside table cells
        columnStyles: {
          0: { cellWidth: 25 }, // Unique ID
          1: { cellWidth: 30 }, // Name
          2: { cellWidth: 25 }, // Date Created
          3: { cellWidth: 25 }, // Category
          4: { cellWidth: 23 }, // Status
          5: { cellWidth: 17 }, // Budget
          6: { cellWidth: 16 }, // Spent
          7: { cellWidth: 16 }, // Charged
          8: { cellWidth: 18 }
        },
        headStyles: { fillColor: [44, 62, 80], textColor: [255, 255, 255], fontStyle: 'bold' }, // Dark header with white text
        // margin: { top: 50 } // Add margin from top
      });

      // 📥 Save PDF File
      doc.save(`Deals_Report_${reportDate}.pdf`);
    }
  }

  generatePDF2() {
    const doc = new jsPDF();
    const reportDate = this.getFormattedDateTime(); // Get current date
    let address = `${this.userData.addressLine1}, ${this.userData.city_name}, ${this.userData.country_name}`;

    // If address length exceeds 150, insert a newline after 150 characters
    if (address.length > 150) {
      const breakpoint = address.lastIndexOf(' ', 150); // Break at the last space before 150
      address = address.slice(0, breakpoint) + '\n' + address.slice(breakpoint + 1);
    }
    // 🏢 Merchant Details
    const merchantDetails = `${this.reportPlaceHolders['LBL_MERCHANT']}: ${this.userData.marketplace_name},
  Status: ${this.getStatusLabel(this.userData.status)}
  ${this.reportPlaceHolders['LBL_ADDRESS']}: ${address}
  Mobile: +${this.profiledata.mobile_country_code + this.profiledata.mobile}
  ${this.reportPlaceHolders['LBL_CONTACT']}: +${this.userData.phone_country_code + this.userData.business_contact_number}
  Report Date: ${reportDate}
      `;

    // Load the brand logo (Base64 or image path)
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = 'assets/images/expenses.png'; //environment.assetsUrl + '/assets/' + this.userData?.marketplace_image // Change path as needed

    img.onload = () => {
      // Convert image to Base64 and add to PDF
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = img.width;
      canvas.height = img.height;
      ctx?.drawImage(img, 0, 0);

      const imgData = canvas.toDataURL("image/png");

      // Add Logo to PDF


      // 🎨 Style the Header (Like an Invoice)
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(18);
      doc.text('DEALS REPORT', 105, 20, { align: 'center' });

      doc.addImage(imgData, 'PNG', 10, 20, 40, 30);
      doc.setFontSize(12);
      doc.setFont('helvetica', 'normal');
      // doc.text(merchantDetails, 60, 27);
      const merchantLines = doc.splitTextToSize(merchantDetails, 130); // Wrap at 130px width
      doc.text(merchantLines, 60, 27);

      // 🏷️ Table Headers
      const tableColumn = ['Unique ID', `${this.reportPlaceHolders['TBL_NAME']}`, `${this.reportPlaceHolders['TBL_CREATED_DATE']}`, `${this.reportPlaceHolders['TBL_AVAILABLE_TO']}`, 'Category', `${this.reportPlaceHolders['TBL_STATUS']}`, `${this.reportPlaceHolders['TBL_BUDGET']}`, `${this.reportPlaceHolders['TBL_TOTAL_SPENT']}`, `${this.reportPlaceHolders['TBL_CHARGED']}`];
      const tableRows: any[] = [];

      // 🔄 Loop through data & format rows
      this.alldealsdata.forEach((deal: any) => {
        tableRows.push([
          deal.uuid,
          deal.product_name,
          deal.created_date,
          deal.available_to,
          deal.category_type,
          this.getStatusLabel(deal.status),
          `${deal.budget}`,
          `${deal.total_spent}`,
          `${deal.spentAlreadyCharged}`,
        ]);
      });

      doc.setLineWidth(0.5); // Set line thickness
      doc.line(10, 63, 200, 63);

      const startY = 68; // Position below line
      doc.setFontSize(11);
      doc.setFont('helvetica', 'bold');

      doc.text(`${this.reportPlaceHolders['LBL_TOTAL_DEALS']}:`, 20, startY);
      doc.text(`${this.reportTotalDeals}`, 49, startY);

      doc.text(`${this.reportPlaceHolders['LBL_TOTAL_BUDGET']}:`, 55, startY);
      doc.text(`$${this.reportTotalBudget}`, 80, startY);

      doc.text(`${this.reportPlaceHolders['LBL_TOTAL_SPENT']}:`, 100, startY);
      doc.text(`$${this.reportTotalSpent}`, 129, startY);

      doc.text(`${this.reportPlaceHolders['LBL_TOTAL_CHARGED']}:`, 150, startY);
      doc.text(`$${this.reportSpendCharged}`, 180, startY);



      // Draw another line below summary for separation
      doc.line(10, startY + 5, 200, startY + 5); // (x1, y1, x2, y2)

      // After drawing totals & before autoTable
      const cardStartY = startY + 10; // push a bit below the summary line
      const cardWidth = 45;
      const cardHeight = 20;
      const gapX = 5;
      const gapY = 10;
      let x = 10;
      let y = cardStartY;

      // Define cards data (match your dashboard)
      const cards = [
        { title: "ACTIVE DEALS", value: this.reportTotalDeals },
        { title: "IMPRESSIONS", value: this.eventsData?.eventCounts?.DEAL_IMPRESSIONS_EVENT.count || 0 },
        { title: "REACH", value: this.eventsData?.eventCounts?.DEAL_IMPRESSIONS_UNIQUE_EVENT.count || 0 },
        { title: "CLICKS", value: this.eventsData?.eventCounts?.DEAL_CLICK_EVENT.count || 0 },
        { title: "COUPON CODE VIEW", value: this.eventsData?.eventCounts?.DEAL_COUPON_CODE_VIEW_EVENT.count || 0 },
        { title: "FAVORITE", value: this.eventsData?.eventCounts?.DEAL_FAVOURITE_EVENT.count || 0 },
        { title: "CTR", value: `${this.eventsData?.ctr || 0}` },
        { title: "MONEY SPEND", value: `$${this.eventsData?.moneySpend || 0}` },
      ];

      // Loop and draw cards in 2 rows
      cards.forEach((card, index) => {
        doc.setDrawColor(200); // light border
        doc.setFillColor(245, 245, 245); // light gray background
        doc.roundedRect(x, y, cardWidth, cardHeight, 3, 3, 'FD'); // filled + border

        doc.setFontSize(8);
        doc.setTextColor(50);
        doc.text(card.title, x + 3, y + 7);

        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(20);
        doc.text(String(card.value), x + 3, y + 15);

        // Move X for next card
        x += cardWidth + gapX;

        // Break into next row after 4 cards
        if ((index + 1) % 4 === 0) {
          x = 10;
          y += cardHeight + gapY;
        }
      });

      // Update table position after cards
      const tableY = y + 5;

      // 🏆 Generate Table with AutoTable
      autoTable(doc, {
        head: [tableColumn],
        body: tableRows,
        startY: tableY,
        margin: { left: 10 },
        theme: 'grid',
        styles: { fontSize: 8, cellPadding: 3 },
        columnStyles: {
          0: { cellWidth: 25 },
          1: { cellWidth: 30 },
          2: { cellWidth: 25 },
          3: { cellWidth: 25 },
          4: { cellWidth: 23 },
          5: { cellWidth: 17 },
          6: { cellWidth: 16 },
          7: { cellWidth: 16 },
          8: { cellWidth: 18 }
        },
        headStyles: { fillColor: [44, 62, 80], textColor: [255, 255, 255], fontStyle: 'bold' }
      });

      // 📥 Save PDF File
      doc.save(`Deals_Report_${reportDate}.pdf`);
    }
  }






  generatePDF() {
    const doc = new jsPDF();
    const reportDate = this.getFormattedDateTime();

    // ==================
    // 1️⃣ Load Header Logo (expenses.png)
    // ==================
    const headerLogoUrl = 'assets/images/expenses.png';

    fetch(headerLogoUrl)
      .then(res => res.blob())
      .then(blob => this.blobToBase64(blob))
      .then(headerLogoData => {
        // 🎨 Header Title
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(18);
        doc.text('DEALS REPORT', 105, 20, { align: 'center' });

        // Add Header Logo
        doc.addImage(headerLogoData, 'PNG', 10, 15, 30, 20);

        // ==================
        // 2️⃣ Merchant Card Layout
        // ==================
        const cardX = 15;
        const cardY = 40;
        const cardWidth = 180;
        const cardHeight = 40;

        doc.setFillColor(255, 255, 255);
        doc.setDrawColor(220);
        doc.roundedRect(cardX, cardY, cardWidth, cardHeight, 3, 3, 'FD');

        // Merchant Logo via Blob
        if (this.userData?.marketplace_image) {
          const merchantLogoUrl =
            environment.assetsUrl + '/assets/' + this.userData.marketplace_image;
          fetch(merchantLogoUrl)
            .then(res => res.blob())
            .then(blob => this.blobToBase64(blob))
            .then(logoData => {
              // Add Merchant Logo
              doc.addImage(logoData, 'JPEG', cardX + 3, cardY + 3, 28, 28);

              // Add Merchant Text
              this.drawMerchantText(doc, cardX + 35, cardY + 9);

              // Continue PDF body
              this.generateReportBody(doc, cardY + cardHeight + 10, reportDate);

              // Save PDF
              doc.save(`Deals_Report_${reportDate}.pdf`);
            })
            .catch(() => {
              // Fallback without logo
              this.drawMerchantText(doc, cardX + 10, cardY + 9);
              this.generateReportBody(doc, cardY + cardHeight + 10, reportDate);
              doc.save(`Deals_Report_${reportDate}.pdf`);
            });
        } else {
          // No merchant logo
          this.drawMerchantText(doc, cardX + 10, cardY + 9);
          this.generateReportBody(doc, cardY + cardHeight + 10, reportDate);
          doc.save(`Deals_Report_${reportDate}.pdf`);
        }
      });
  }

  // ✅ Convert Blob → Base64 (helper)
  private blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  // ✅ Draw Merchant Text
  private drawMerchantText(doc: any, textX: number, textY: number) {
    const reportDate = this.getFormattedDateTime();
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);
    doc.text(this.userData.marketplace_name || 'Merchant', textX, textY);

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);

    textY += 5;
    doc.text(
      `Status: ${this.getStatusLabel(this.userData.status)}`,
      textX,
      textY
    );
    textY += 5;
    let address = `${this.userData.addressLine1 || ''}, ${this.userData.city_name || ''}, ${this.userData.country_name || ''}`;
    if (address.length > 60) {
      address = doc.splitTextToSize(address, 120);
    }
    doc.text(`Address: ${address}`, textX, textY);

    textY += 5;
    doc.text(
      `Business Contact: +${this.userData.phone_country_code || ''}${this.userData.business_contact_number || ''}`,
      textX,
      textY
    );
    textY += 5;
    doc.text(
      `Mobile: +${this.profiledata.mobile_country_code + this.profiledata.mobile}`,
      textX,
      textY
    );
    textY += 5;
    doc.text(
      `Report Date: ${reportDate}`,
      textX,
      textY
    );
    textY += 5;
    if (this.userData.available_from) {
      doc.text(
        `Merchant available from: ${moment(this.userData.available_from).format(
          'DD/MM/YYYY'
        )}`,
        textX,
        textY
      );
    }
  }


  // ✅ Body (Totals + Cards + Table)
  private generateReportBody(doc: any, startY: number, reportDate: string) {
    // Totals
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');

    doc.text(`${this.reportPlaceHolders['LBL_TOTAL_DEALS']}:`, 20, startY);
    doc.text(`${this.reportTotalDeals}`, 49, startY);

    doc.text(`${this.reportPlaceHolders['LBL_TOTAL_BUDGET']}:`, 55, startY);
    doc.text(`$${this.reportTotalBudget}`, 80, startY);

    doc.text(`${this.reportPlaceHolders['LBL_TOTAL_SPENT']}:`, 100, startY);
    doc.text(`$${this.reportTotalSpent}`, 129, startY);

    doc.text(`${this.reportPlaceHolders['LBL_TOTAL_CHARGED']}:`, 150, startY);
    doc.text(`$${this.reportSpendCharged}`, 180, startY);

    doc.line(10, startY + 5, 200, startY + 5);

    // Cards Section
    const cardStartY = startY + 10;
    const cardWidth = 45;
    const cardHeight = 20;
    const gapX = 5;
    const gapY = 10;
    let x = 10;
    let y = cardStartY;

    const cards = [
      { title: 'ACTIVE DEALS', value: this.eventsData?.activeDealsCount || 0 },
      { title: "IMPRESSIONS", value: this.eventsData?.eventCounts?.DEAL_IMPRESSIONS_EVENT.count || 0 },
      { title: "REACH", value: this.eventsData?.eventCounts?.DEAL_IMPRESSIONS_UNIQUE_EVENT.count || 0 },
      { title: "CLICKS", value: this.eventsData?.eventCounts?.DEAL_CLICK_EVENT.count || 0 },
      { title: "COUPON CODE VIEW", value: this.eventsData?.eventCounts?.DEAL_COUPON_CODE_VIEW_EVENT.count || 0 },
      { title: "FAVORITE", value: this.eventsData?.eventCounts?.DEAL_FAVOURITE_EVENT.count || 0 },
      { title: 'CTR', value: `${this.eventsData?.ctr || 0}` },
      { title: 'MONEY SPEND', value: `${this.eventsData?.moneySpent || 0}` },
    ];


    cards.forEach((card, index) => {
      doc.setDrawColor(200);
      doc.setFillColor(245, 245, 245);
      doc.roundedRect(x, y, cardWidth, cardHeight, 3, 3, 'FD');

      doc.setFontSize(8);
      doc.setTextColor(50);
      doc.text(card.title, x + 3, y + 7);

      doc.setFontSize(11);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(20);
      doc.text(String(card.value), x + 3, y + 15);

      x += cardWidth + gapX;
      if ((index + 1) % 4 === 0) {
        x = 10;
        y += cardHeight + gapY;
      }
    });

    // Table
    const tableY = y + 5;
    const tableColumn = [
      'Unique ID',
      `${this.reportPlaceHolders['TBL_NAME']}`,
      `${this.reportPlaceHolders['TBL_CREATED_DATE']}`,
      `${this.reportPlaceHolders['TBL_AVAILABLE_TO']}`,
      'Category',
      `${this.reportPlaceHolders['TBL_STATUS']}`,
      `${this.reportPlaceHolders['TBL_BUDGET']}`,
      `${this.reportPlaceHolders['TBL_TOTAL_SPENT']}`,
      `${this.reportPlaceHolders['TBL_CHARGED']}`,
    ];
    const tableRows: any[] = [];

    this.alldealsdata.forEach((deal: any) => {
      tableRows.push([
        deal.uuid,
        deal.product_name,
        deal.created_date,
        deal.available_to,
        deal.category_type,
        this.getStatusLabel(deal.status),
        `${deal.budget}`,
        `${deal.total_spent}`,
        `${deal.spentAlreadyCharged}`,
      ]);
    });

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: tableY,
      margin: { left: 10 },
      theme: 'grid',
      styles: { fontSize: 8, cellPadding: 3 },
      columnStyles: {
        0: { cellWidth: 25 },
        1: { cellWidth: 30 },
        2: { cellWidth: 25 },
        3: { cellWidth: 25 },
        4: { cellWidth: 23 },
        5: { cellWidth: 17 },
        6: { cellWidth: 16 },
        7: { cellWidth: 16 },
        8: { cellWidth: 18 },
      },
      headStyles: {
        fillColor: [44, 62, 80],
        textColor: [255, 255, 255],
        fontStyle: 'bold',
      },
    });
  }


  getFormattedDateTime(): string {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }

  profiledata: any
  getUserData() {
    debugger
    this.service.getUserProfileDetails().subscribe((res: any) => {
      this.profiledata = res?.data;
    });
  }


}

